import { CuttingPanelBaseSlot } from './cutting-panel-base-slot.model';

export interface FacadeAvailableSlot extends CuttingPanelBaseSlot {
  availablePlates: FacadeSlotAvailablePlatesEnum;
}

export enum FacadeSlotAvailablePlatesEnum {
  Face,
  Back,
  FaceAndBack,
  Edge,
}
